const invertedMessages = {
  Close: 'CloseLabel',
  Loading: 'CERTS_LOADING',
};

export default invertedMessages;
